<template>
  <div>
    <div v-if="isMobile">
      <app-jazb
        v-for="index in history.length"
        :key="index"
        :history="history[index - 1]"
        @removeRequest="removeRequest"
      >
      </app-jazb>
    </div>
    <div v-else>
      <v-data-table
        :items="history"
        :headers="historyHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        show-expand
        item-key="Fserial"
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <br />
            <template v-if="item.ShahrestanName != ''">
              <b>شهر محل سکونت:</b>
              <br />
              <span v-html="item.ShahrestanName"></span>

              <br />
              <br />
            </template>
            <template v-if="item.D_Priority != ''">
              <b>اولویت های طلبه: </b>
              <br />
              <span v-html="item.D_Priority"></span>

              <br />
              <br />
            </template>
            <b>ملاحظات طلبه:</b>
            <br />
            <span v-html="item.Description"></span>

            <br />
            <br />
            <b>نظر مدرسه: </b>
            <span v-html="item.Des_School"></span>
            <br />
            <br />
            <b>نظر ستاد تبلیغ: </b>
            <span v-html="item.Des_Setad"></span>
            <br />
            <br />
            <b>نظر حراست: </b>
            <span v-html="item.Des_Herasat"></span>

            <br />
            <br />
            <b>تاریخ مصاحبه:</b>
            <span v-html="item.D_Mosahebe"></span>

            <br />
            <br />
            <b>ساعت مصاحبه:</b>
            <span v-html="item.T_Mosahebe"></span>

            <br />
            <br />
            <b>مکان مصاحبه:</b>
            <span v-html="item.P_Mosahebe"></span>

            <br />
            <br />
          </td>
        </template>
        <template v-slot:[`item.Removable`]="{ item }">
          <v-btn
            class="grid"
            v-if="item.D_Mosahebe === ''"
            color="red white--text"
            rounded
            @click="removeRequest(item)"
          >
            حذف درخواست
          </v-btn>
        </template>
      </v-data-table>
    </div>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Jazb from "./Jazb";
import { getJazbHistory, CancelRequest } from "@/api/jazb";
import Dialog from "@/components/Dialog";

export default {
  components: {
    appJazb: Jazb,
    appDialog: Dialog,
  },
  data() {
    return {
      historyHeaders: [
        {
          text: "نام دوره",
          value: "Title",
        },
        { text: "توضیحات", value: "data-table-expand" },
        { text: "", value: "Removable" },
      ],
      history: [],
    };
  },
  created() {
    this.getHistory();
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },

  methods: {
    convertStateToString(state) {
      return state === true ? "تایید" : "";
    },
    getHistory() {
      return new Promise((resolve, reject) => {
        getJazbHistory()
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.history = response.data;
            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },

    removeRequest(index) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index.Fserial);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این درخواست هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        CancelRequest(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

            if (data.Success) {
              this.getHistory();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>
